webpackJsonp([107436447393213],{

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _block = __webpack_require__(10);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _myTitle = __webpack_require__(12);
	
	var _myTitle2 = _interopRequireDefault(_myTitle);
	
	var _blockCover = __webpack_require__(17);
	
	var _blockCover2 = _interopRequireDefault(_blockCover);
	
	var _contact = __webpack_require__(57);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MentionsLegales = function MentionsLegales() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _block2.default,
	      { className: 'block-grey-background' },
	      _react2.default.createElement(
	        _myTitle2.default,
	        null,
	        'Mentions l\xE9gales'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row justify-content-center' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12 col-md-9 ' },
	          _react2.default.createElement(
	            'p',
	            { className: 'light fs-16 lh-23 mb-4' },
	            _react2.default.createElement(
	              'strong',
	              { className: 'color-red' },
	              'CNIL : D\xE9clarations l\xE9gales et obligatoires'
	            ),
	            _react2.default.createElement('br', null),
	            'Conform\xE9ment \xE0 la loi en vigueur au 1er juin 2000, ce site Internet a fait l\u2019objet d\u2019une d\xE9claration aupr\xE8s de la CNIL. Conform\xE9ment \xE0 la loi fran\xE7aise N\xB778-17 du 6 janvier 1978 relative \xE0 l\u2019informatique, aux fichiers et aux libert\xE9s, vous disposez d\u2019un droit d\u2019acc\xE8s, de modification de rectification et de suppression de donn\xE9es qui vous concernent. Pour exercer ce droit, \xE9crivez nous.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'strong',
	              { className: 'color-red' },
	              'Identification de l\u2019\xE9diteur :'
	            ),
	            ' S.A.R.L. Br\xE9',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'strong',
	              { className: 'color-red' },
	              'Responsable de la publication :'
	            ),
	            ' S.A.R.L. Br\xE9',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'strong',
	              { className: 'color-red' },
	              'Responsable de la r\xE9daction :'
	            ),
	            ' S.A.R.L. Br\xE9',
	            _react2.default.createElement('br', null),
	            'Personne charg\xE9e du droit \xE0 l\'acc\xE8s et \xE0 la rectification, de l\'information, conform\xE9ment \xE0 la loi 78-17 du 06.01.1978',
	            _react2.default.createElement('br', null),
	            'e-mail : ',
	            _react2.default.createElement(
	              'a',
	              { href: 'mailto:contact@menuiseriebre.fr' },
	              'contact@menuiseriebre.fr'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'strong',
	              { className: 'color-red' },
	              'Fournisseur d\'h\xE9bergement'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Nom :'
	            ),
	            ' Netlify ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'strong',
	              null,
	              'D\xE9nomination ou raison sociale :'
	            ),
	            ' Netlify',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'strong',
	              { className: 'color-red' },
	              'Conception et r\xE9alisation graphique du site'
	            ),
	            _react2.default.createElement('br', null),
	            'cowagency - ',
	            _react2.default.createElement(
	              'a',
	              { href: 'http://www.cowagency.com', target: '_blank' },
	              'www.cowagency.com'
	            ),
	            _react2.default.createElement('br', null),
	            '4, avenue Laurent Cely, Tour d\'asni\xE8res, Hall C - 92600 Asni\xE8res-sur-Seine - 09 52 25 62 59',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'strong',
	              { className: 'color-red' },
	              'Compatibilit\xE9'
	            ),
	            _react2.default.createElement('br', null),
	            '- Tout navigateur Niveau 4 minimum - Ecran 1024x768 - Millions couleurs.',
	            _react2.default.createElement('br', null),
	            '- Pour un meilleur confort de lecture, vous devez disposer des modules libres suivant. ',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'strong',
	              { className: 'color-red' },
	              'Contenu du site : mise en garde '
	            ),
	            _react2.default.createElement('br', null),
	            'www.menuiseriebre.fr est un site d\u2019informations. La S.A.R.L. Br\xE9 ne saurait garantir l\u2019exactitude, la compl\xE9tude, l\u2019actualit\xE9 et la mise \xE0 jour des informations diffus\xE9es sur son site Web. Le visiteur reconna\xEEt que l\u2019utilisation de ces informations sont sous sa responsabilit\xE9 exclusive.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'strong',
	              { className: 'color-red' },
	              'Droits d\'auteur et de reproduction'
	            ),
	            _react2.default.createElement('br', null),
	            'Ce site est soumis \xE0 la l\xE9gislation fran\xE7aise et internationale sur les droits d\'auteur. Tous les droits de reproduction, sur quelque support que ce soit, sont r\xE9serv\xE9s. La reproduction et l\'utilisation du contenu de tout ou partie de ce site autres qu\'individuelles et priv\xE9es sont interdites, sauf autorisation expresse et pr\xE9alable de l\'\xE9diteur.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	              'strong',
	              { className: 'color-red' },
	              'Droits de propri\xE9t\xE9 '
	            ),
	            _react2.default.createElement('br', null),
	            'Article L. 122-4 du code de la propri\xE9t\xE9 intellectuelle : Toute repr\xE9sentation ou reproduction int\xE9grale ou partielle faite sans le consentement de l\u2019auteur ou de ses ayants droit ou ayants cause est illicite. Il en est de m\xEAme pour la traduction, l\u2019adaptation ou la transformation, l\u2019arrangement ou la reproduction par un art ou un proc\xE9d\xE9 quelconque.',
	            _react2.default.createElement('br', null),
	            _react2.default.createElement('br', null),
	            'Si vous souhaitez reproduire des documents contenus dans notre site, uniquement \xE0 des fins non lucratives, vous devez avant toute diffusion obtenir notre autorisation \xE9crite pr\xE9alable. Pour cela, vous devez nous adresser une demande \xE9crite par e-mail ',
	            _react2.default.createElement(
	              'a',
	              { href: 'mailto:contact@menuiseriebre.fr' },
	              'contact@menuiseriebre.fr'
	            ),
	            ' en pr\xE9cisant le contenu exact de ce que vous souhaitez reproduire. Apr\xE8s accord, il vous sera demand\xE9 de citer pr\xE9cis\xE9ment les sources.'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = MentionsLegales;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-mentions-legales-js-ca6f26fc8e6cab369aea.js